import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { useAuth } from 'hooks/UseAuth'
import { ReactNode, useState } from 'react'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ReviewRequestCard } from './ReviewRequestCard'

interface Props {
  request?: InformalFeedbackRequest
  channel?: ChannelType | DesignChannel
  assetType: 'article' | 'design'
  alternativeContent?: ReactNode
}

export const ReviewRequestCardContainer = ({ request, channel, assetType, alternativeContent }: Props) => {
  const auth = useAuth()
  const [cardDismissed, setCardDismissed] = useState(false)

  const iAmReviewer = request?.reviews.find((review) => review.reviewer.id === auth?.id)
  const isMyRequest = request?.requester.id === auth?.id
  const showRequestCard = !!request && (isMyRequest || iAmReviewer)
  const isDismissed = request?.cleanup_dismissed || cardDismissed

  if (!showRequestCard || isDismissed) {
    if (alternativeContent) return <>{alternativeContent}</>

    return null
  }

  return <ReviewRequestCard request={request} channel={channel} assetType={assetType} onDismiss={setCardDismissed} />
}
